import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


// OTHER MODULE IMPORTS

import { SharedModule } from '../../shared.module';
import { MaterialsModule } from '../../materials.module';
import { MainQuizRoutingModule } from './main-quiz-routing.module';

// IMPORT QUIZ MODULE COMPONENT
import { MainQuizComponent } from './main-quiz.component';
import { CreateQuizComponent } from '../create-quiz/create-quiz.component';
import { AppearQuizComponent } from '../appear-quiz/appear-quiz.component';
import { AddQuizModalComponent } from '../add-quiz-modal/add-quiz-modal.component';
import { QuizListModalComponent } from '../quiz-list-modal/quiz-list-modal.component';
import { SummaryCriteriaComponent } from '../summary-criteria/summary-criteria.component';
import { AssessmentComponent } from '../assessment/assessment.component';


@NgModule({
  declarations: [
    MainQuizComponent,
    CreateQuizComponent,
    AppearQuizComponent,
    AddQuizModalComponent,
    QuizListModalComponent,
    SummaryCriteriaComponent,
    AssessmentComponent
  ],
  imports: [
    CommonModule,
    MainQuizRoutingModule,
    SharedModule,
    MaterialsModule,
  ],
  exports: [
    AssessmentComponent,
    AddQuizModalComponent,
    QuizListModalComponent,
  ],
  entryComponents: [
    AddQuizModalComponent,
    QuizListModalComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MainQuizModule { }
